import { InjectionToken } from '@angular/core';
import { TradingQueryPort } from '../ports/trading-query.port';

export const TRADING_QUERY_TOKEN = new InjectionToken<TradingQueryPort>('TradingQueryPort');
